function parse_string_payload(payload) {
  let parsed_payload;

  try {
    parsed_payload = JSON.parse(payload);
  } catch {
    parsed_payload = {};
  }

  return parsed_payload;
}

export const parse_api_data = (payload) => (
  typeof payload === 'string' ? parse_string_payload(payload) : (payload || {})
);

export function unwrap_items(payload) {
  const response_data = parse_api_data(payload?.data ?? payload);
  const items = response_data.data || response_data.projects || response_data.users || response_data;
  return Array.isArray(items) ? items : [];
}

function get_entity_type_fallback_label(index = 0) {
  return `Entity Type ${index + 1}`;
}

function get_primary_entity_type_label_value(item = {}) {
  return item?.entity_type_name || item?.name || '';
}

function get_secondary_entity_type_label_value(item = {}) {
  return item?.domain_name || item?.domain || '';
}

export function get_entity_type_label_value(item = {}, index = 0) {
  return (
    get_primary_entity_type_label_value(item) ||
    get_secondary_entity_type_label_value(item) ||
    get_entity_type_fallback_label(index)
  );
}

export function get_entity_type_id_value(item = {}) {
  return Number(item?.id || item?.entity_type_id || 0);
}

export function get_entity_type_project_id_value(item = {}) {
  return Number(item?.project_id || item?.project?.id || 0) || null;
}

export function is_coordinator_role(role) {
  return String(role || '').trim().toLowerCase().includes('coordinator');
}

export const is_valid_email = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
export const is_valid_phone_number = (phone_number) => /^\d{10}$/.test(String(phone_number || '').trim());
export const has_valid_name = (name) => /^[A-Za-z][A-Za-z\s'-]{1,49}$/.test(String(name || '').trim());

export function get_default_role(roles = []) {
  return roles[0]?.role || '';
}

export function get_project_display_name(project) {
  return project?.project_name || project?.name || `Project ${project?.id || ''}`;
}

export function get_empty_assign_form() {
  return {
    user: null,
    project_ids: [],
    original_project_ids: [],
    project_search: ''
  };
}

function create_contact_form(role = '') {
  return {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    sms_number: '',
    whatsapp_number: '',
    sms_same_as_phone: false,
    whatsapp_same_as_phone: false,
    role,
    entity_type_id: ''
  };
}

export function create_user_management_data() {
  return {
    users: [],
    roles: [],
    entity_type_options: [],
    projects: [],
    is_loading: false,
    roles_loading: false,
    entity_types_loading: false,
    projects_loading: false,
    assigned_projects_loading: false,
    creating_user: false,
    updating_user: false,
    assigning_user: false,
    create_form: create_contact_form(),
    edit_form: {
      user_id: null,
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      sms_number: '',
      whatsapp_number: '',
      sms_same_as_phone: false,
      whatsapp_same_as_phone: false,
      role_id: '',
      entity_type_id: '',
      entity_type_name: ''
    },
    assign_form: get_empty_assign_form(),
    show_project_dropdown: false,
    pagination: null
  };
}

export function build_create_form(roles = []) {
  return create_contact_form(get_default_role(roles));
}

export function build_edit_form(user = {}) {
  return {
    user_id: user.id,
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    email: user.email || '',
    phone_number: user.phone_number || '',
    sms_number: user.sms_number || '',
    whatsapp_number: user.whatsapp_number || '',
    sms_same_as_phone: (user.sms_number || '') === (user.phone_number || '') && !!user.phone_number,
    whatsapp_same_as_phone: (user.whatsapp_number || '') === (user.phone_number || '') && !!user.phone_number,
    role_id: user.role_id || '',
    entity_type_id: user.entity_type_id ? String(user.entity_type_id) : '',
    entity_type_name: user.entity_type_name || ''
  };
}

export const user_management_computed = {
  active_users_count() {
    return this.users.filter((user) => user.is_active !== false).length;
  },

  inactive_users_count() {
    return this.users.filter((user) => user.is_active === false).length;
  },

  filtered_projects() {
    const search = String(this.assign_form.project_search || '').toLowerCase().trim();
    if (!search) return this.projects;

    return this.projects.filter((project) =>
      this.project_display_name(project).toLowerCase().includes(search)
    );
  },

  selected_project_name() {
    const selected_ids = Array.isArray(this.assign_form.project_ids)
      ? this.assign_form.project_ids
      : [];

    if (!selected_ids.length) return 'Select Projects';

    if (selected_ids.length === 1) {
      const selected_project = this.projects.find(
        (project) => String(project.id) === String(selected_ids[0])
      );
      return selected_project ? this.project_display_name(selected_project) : '1 project selected';
    }

    return `${selected_ids.length} projects selected`;
  }
};
